import { Box, Typography } from "@mui/material";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import { TypeTableHead } from "../../type/componentsType/TkTable";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const explain1 = {
  5: (
    <Box>
      施設を選択すると職員の登録内容が表示されます。
      <br />
      　【４月１日までに採用した職員はすべて登録されているか確認してください。】
    </Box>
  ),
  6: (
    <Box>
      施設を選択すると職員の登録内容が表示されます。
      <br />
      　【４月１日現在の職員の配置換え手続きは終わっているか確認してください。】
    </Box>
  ),
  7: (
    <Box>
      施設を選択すると職員の登録内容が表示されます。
      <br />
      　【４月１日現在の俸給額に更新されているか確認してください。】
    </Box>
  ),
  8: (
    <Box>
      施設を選択すると職員の登録内容が表示されます。
      <br />
      　【３月３１日までの全被共済職員の従業状況はすべて更新されているか確認してください。】
    </Box>
  ),
};

const explain2 = {
  5: (
    <Typography>
      ４月１日現在の採用した職員をすべて登録されていない場合は、画面下部の「戻る」ボタンから「掛金納付対象職員届提出時の事前確認」画面に戻り、「確認５」で「いいえ」を選択し、登録してください。
    </Typography>
  ),

  6: (
    <Typography>
      ４月１日現在の職員の配置換え手続きが終わっていない場合は、画面下部の「戻る」ボタンから「掛金納付対象職員届提出時の事前確認」画面に戻り、「確認６」で「いいえ」を選択し、配置換えの手続きを行ってください。
    </Typography>
  ),

  7: (
    <Typography>
      ４月１日現在の俸給額に更新されていない場合は、画面下部の「戻る」ボタンから「掛金納付対象職員届提出時の事前確認」画面に戻り、「確認７」で「いいえ」を選択し、更新してください。
    </Typography>
  ),

  8: (
    <Typography>
      ３月３１日までの全被共済職員の従業状況をすべて更新されていない場合は、画面下部の「戻る」ボタンから「掛金納付対象職員届提出時の事前確認」画面に戻り、「確認８」で「いいえ」を選択し、更新してください。
    </Typography>
  ),
};

const searchFormList: any = [
  {
    label: "職員名",
    keyword: "name",
    type: "label",
    inputProps: {
      maxLength: 48,
    },
  },
];

const searchFormSchema = {
  name: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
  },
};

const headList: TypeTableHead[] = [
  {
    headTitle: (
      <>
        氏名
        <TkHelpIcon
          helpMessage={
            <>
              登録されている被共済職員の氏名です。外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字を使用されている場合は、正しく表示されていない恐れがあります。
              <br />
              表示されていない場合は、常用漢字を用いて入力をお願いします。
              <br />
              なお、外国人については、フリガナ、漢字欄ともに「カタカナ」で入力をしてください。
            </>
          }
        />
        <br />
        生年月日
        <TkHelpIcon helpMessage="被共済職員の生年月日です。" />
        <br />
        性別
      </>
    ),
  },
  {
    headTitle: (
      <>
        加入日
        <br />
        加入資格
        <TkHelpIcon
          helpMessage={
            <>
              加入資格については、
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫加入要件について.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              をご確認ください。
            </>
          }
        />
        <br />
        職種
        <TkHelpIcon
          helpMessage={
            <>
              被共済職員の職種です。詳しくは、
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫職種について.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              をご確認ください。
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        在籍期間
        <TkHelpIcon
          helpMessage={
            <>
              4月1日から7月31日までは加入日から前々年度３月末までの期間です。
              <br />
              8月1日から3月31日までは加入日から前年度３月末までの期間です。
              <br />
              なお、在籍期間には不算入期間（「ならない月」及び「育休期間」の1/2）は含みますが、契約対象外施設等に在籍していた期間は共済法上は制度上の退職にあたるため除かれています。
            </>
          }
        />
        <br />
        有効期間
        <TkHelpIcon
          helpMessage={
            <>
              在籍期間から不算入期間（「ならない月」及び「育休期間」の1/2）を除いた期間です。有効期間が退職手当金の算定基礎となります。
              <br />
              ※表示されている有効期間は前々年度３月末までの期間です。
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        4/1の俸給表の額
        <br />
        俸給の調整額
      </>
    ),
  },
  {
    headTitle: (
      <>
        ならない月
        <TkHelpIcon
          helpMessage={
            <>
              前年度における「ならない月」です。詳しくは
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫「なる月」「ならない月」について.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              をご確認ください。
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        育休
        <TkHelpIcon
          helpMessage={
            <>
              育児休業については、
              <a
                href={`${
                  process.env.PUBLIC_URL ?? ""
                }/assets/pdf/≪別紙≫育児休業について.pdf`}
                target="_blank"
                rel="noreferrer"
              >
                こちら
              </a>
              をご確認ください。
            </>
          }
        />
      </>
    ),
  },
  {
    headTitle: (
      <>
        他共済
        <TkHelpIcon helpMessage="当機構の共済制度とは別に都道府県の共済制度に加入している場合は「○」と表示されます。" />
      </>
    ),
  },
];

const explain3 = (
  <>
    <br />
    ※職員番号★…平成１８年３月３１日までの加入者
    <br />
    ※職員番号◆…平成１８年４月１日から平成２８年３月３１日までの加入者
    <br />
    ※職員番号☆…施設転換前の加入者
    <br />
    <br />
    ※加入資格ア、イ、ウの説明
    <br />
    　ア…雇用期間に定めのない職員（いわゆる正規職員）
    <br />
    　イ…一年以上の雇用期間を定めて使用されている職員で、労働時間が就業規則で定める正規職員の所定労働時間の３分の２以上のもの
    <br />
    　ウ…一年未満の雇用期間を定めて使用され、期間の更新により引き続き１年を経過した職員で、労働時間が就業規則で定める正規職員の所定労働時間の３分の２以上のもの
  </>
);

export {
  searchFormList,
  searchFormSchema,
  headList,
  explain1,
  explain2,
  explain3,
};
